import React from "react";
import { View, StyleSheet } from "react-native";
import BaseController from "../../common/base/BaseController";
import BaseMarketingController from "./BaseMarketingController";
import NtMarketingPageContainer from "../components/general/NtMarketingPageContainer";
import NtGuestAppSection from "../components/guestapp/NtGuestAppSection";
import NtGuestVoiceSection from "../components/guestapp/NtGuestVoiceSection";
import NtGuestVideoSection from "../components/guestapp/NtGuestVideoSection";
import NtGuestChatSection from "../components/guestapp/NtGuestChatSection";
import NtGuestInfoSection from "../components/guestapp/NtGuestInfoSection";

class GuestAppController extends BaseMarketingController {
  state = {};
  render() {
    return (
      <NtMarketingPageContainer style={styles.container}>
        <NtGuestAppSection />
        <NtGuestVoiceSection />
        <NtGuestVideoSection />
        <NtGuestChatSection />
        <NtGuestInfoSection />
      </NtMarketingPageContainer>
    );
  }
}

const styles = StyleSheet.create({
  container: {},
});

export default GuestAppController;
